import { UserManager, UserManagerSettings } from "oidc-client-ts";
import { signOut } from "../auth/auth.service";
import {
  backendUri,
  clientId,
  postLogoutRedirectUri,
  redirectUri,
  scopes,
} from "./openid-settings";

export function getClientSettings(): UserManagerSettings {
  return {
    authority: backendUri as any,
    client_id: clientId,
    redirect_uri: redirectUri as any,
    post_logout_redirect_uri: postLogoutRedirectUri as any,
    response_type: "code",
    filterProtocolClaims: true,
    loadUserInfo: false,
    scope: scopes,
    client_secret: "",
    extraTokenParams: { scope: scopes },
    automaticSilentRenew: false,
    monitorSession: true,
  };
}

let manager: UserManager | undefined;
export function getManager() {
  manager ??= new UserManager(getClientSettings());
  return manager;
}

export async function openExternalLoginPopup(provider: string) {
  try {
    await getManager().signinRedirect({
      extraQueryParams: { provider: provider },
    } as any);
  } catch (e) {
    console.error("Error during external authentication", e);
    throw e;
  }
}

export async function redirectCallback() {
  try {
    const user = await getManager().signinRedirectCallback();
    return user;
  } catch (e) {
    console.error("Error during external authentication", e);
    throw e;
  }
}

/* export async function completeAuthorization() {
  return getManager().signinRedirectCallback();
} */

export async function completeAuthorization() {
  try {
    // Ensure we're using the same manager instance used for the initial request
    const manager = getManager();

    // Check if we're in a callback state
    if (await manager.signinSilent()) {
      return manager.getUser();
    }

    // Process the redirect callback
    return manager.signinRedirectCallback();
  } catch (error) {
    console.error("Error completing authorization:", error);
    throw error;
  }
}

export async function signoutRequest(shouldSignOut = true) {
  /*     const cookies = new Cookies();
  const accessToken = cookies.get("hdb-token"); */

  signOut();
  // const clear = await getManager().clearStaleState();
  // const remove = await getManager().removeUser();

  /* to handle single session we are clearing all the local data to show that the user is logged out but not from the backend, as logged in from other device or browser */
  // if (accessToken && shouldSignOut) {
  if (shouldSignOut) {
    await getManager().signoutRedirect({
      // id_token_hint: accessToken,
    });

    localStorage.setItem("serverSignedOut", JSON.stringify(true));
  } else {
    localStorage.setItem("serverSignedOut", JSON.stringify(false));
  }

  return "signed out!";
}
